module.exports = __webpack_public_path__ + "static/media/Veiligheid-en-gezonheidsbeleid-December-2019.5f5db6d5.pdf";